import { Company } from "../generated/types";
import { apiFetchJson } from "./apiFetchRoute";

export const fetchCompanies = async (): Promise<{
  Companys: Company[];
  error: string | null;
}> => {
  try {
    const data = await apiFetchJson("getCompanies", undefined);

    return { Companys: data, error: null };
  } catch (err) {
    console.error("Erreur:", err);
    return { Companys: [], error: "Impossible de charger les entreprises" };
  }
};
